'use client';

import { ReactNode, useRef } from 'react';
import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertProps,
  CloseButton,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
} from '@chakra-ui/react';

interface Props {
  isOpen?: boolean;
  onClose(): void;
  content?: ReactNode;
  status?: AlertProps['status'];
}

export type AlertDialogProps = Props;

export const AlertDialog = (props: Props) => {
  const { isOpen = false, onClose, status, content } = props;

  const alertRef = useRef<HTMLDivElement>(null);

  return (
    <Modal
      motionPreset="slideInBottom"
      onClose={onClose}
      isOpen={isOpen}
      isCentered
    >
      <ModalOverlay />

      <ModalContent>
        <ModalBody p={0}>
          <Alert
            ref={alertRef}
            status={status}
            variant="left-accent"
            rounded="md"
            w="full"
            justifyContent="space-between"
          >
            <HStack>
              <AlertIcon alignSelf="flex-start" />

              <AlertDescription color="blue.800">{content}</AlertDescription>
            </HStack>

            <CloseButton
              onClick={onClose}
              alignSelf="flex-start"
              position="relative"
              top={-1}
              right={-1}
            />
          </Alert>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default AlertDialog;
